import api from './api';

export interface AppNotification {
  id: number;
  user_id: number;
  type: string;
  title: string;
  body: string;
  data?: {
    case_id?: number;
    case_name?: string;
    template_name?: string;
    email_log_id?: number;
    mail_class?: string;
  };
  read_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface NotificationPreferences {
  email_snoozed_until: string | null;
  is_snoozed: boolean;
}

export interface PaginatedNotifications {
  data: AppNotification[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

class NotificationService {
  async getNotifications(page = 1, perPage = 20) {
    const response = await api.get(`/notifications?page=${page}&per_page=${perPage}`);
    return response.data as {
      success: boolean;
      data: PaginatedNotifications;
      unread_count: number;
    };
  }

  async getUnreadCount() {
    const response = await api.get('/notifications/unread-count');
    return response.data as { success: boolean; count: number };
  }

  async markRead(id: number) {
    const response = await api.patch(`/notifications/${id}/read`);
    return response.data;
  }

  async markAllRead() {
    const response = await api.post('/notifications/read-all');
    return response.data;
  }

  async getPreferences() {
    const response = await api.get('/notification-preferences');
    return response.data as { success: boolean; data: NotificationPreferences };
  }

  async updateSnooze(snoozedUntil: string | null) {
    const response = await api.put('/notification-preferences/snooze', {
      snoozed_until: snoozedUntil,
    });
    return response.data as { success: boolean; data: NotificationPreferences };
  }
}

export default new NotificationService();
